"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auctionReminderTemplateFr = void 0;
exports.auctionReminderTemplateFr = {
    root: {
        type: "EmailLayout",
        data: {
            backdropColor: "#F9F9F9",
            canvasColor: "#F9F9F9",
            borderColor: null,
            textColor: "#000000",
            fontFamily: "MODERN_SANS",
            childrenIds: [
                "block-1788511558256-1",
                "block-1788511558256-2",
                "block-1788511558256-3",
                "block-1788511558256-4",
                "block-1788511558256-5",
                "block-1788511558256-6",
                "block-1788511558256-7",
            ],
        },
    },
    "block-1788511558256-1": {
        type: "Image",
        data: {
            style: {
                backgroundColor: "#ffffff",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
                textAlign: "center",
            },
            props: {
                url: "https://www.zeffy.com/images/emails/reminder-notification-bell.jpg",
                width: 162,
                alt: "",
                linkHref: null,
                contentAlignment: "middle",
            },
        },
    },
    "block-1788511558256-2": {
        type: "Html",
        data: {
            style: {
                color: "#0f0e5b",
                backgroundColor: "#ffffff",
                fontSize: 22,
                fontFamily: "MODERN_SANS",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
                textAlign: "center",
            },
            props: {
                contents: '<div id="email-content-wrapper"><style>#email-content-wrapper p, #email-content-wrapper h1, #email-content-wrapper h2, #email-content-wrapper h3, #email-content-wrapper h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }\n#email-content-wrapper p, #email-content-wrapper li, #email-content-wrapper ul, #email-content-wrapper ol { line-height: 1.5; }\n#email-content-wrapper li:has(> ul), #email-content-wrapper li:has(> ol) { list-style: none; }\n#email-content-wrapper h1 { font-weight: 500; font-size: 40px; line-height: 1.2; letter-spacing: -0.25px; }\n#email-content-wrapper h2 { font-weight: 500; font-size: 28px; line-height: 1.25; letter-spacing: 0; }\n#email-content-wrapper h3 { font-weight: 500; font-size: 22px; line-height: 1.3; letter-spacing: 0.25px; }\n#email-content-wrapper h4 { font-weight: 500; font-size: 18px; line-height: 1.35; letter-spacing: 0; }\n@media only screen and (max-width: 480px) {\n  #email-content-wrapper h1 { font-size: 34px !important; line-height: 1.2 !important; }\n  #email-content-wrapper h2 { font-size: 24px !important; line-height: 1.25 !important; }\n  #email-content-wrapper h3 { font-size: 20px !important; line-height: 1.3 !important; }\n  #email-content-wrapper h4 { font-size: 16px !important; line-height: 1.35 !important; }\n}</style><h3 style="text-align: center"><strong><strong>Rappel !</strong></p>\n<p>Faites vos derni&egrave;res mises, l’encan se termine bient&ocirc;t.</strong></h3></div>',
            },
        },
    },
    "block-1788511558256-3": {
        type: "Html",
        data: {
            style: {
                color: "#0f0e5b",
                backgroundColor: "#ffffff",
                fontSize: 14,
                fontFamily: "MODERN_SANS",
                textAlign: "left",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
            },
            props: {
                contents: '<div id="email-content-wrapper"><style>#email-content-wrapper p, #email-content-wrapper h1, #email-content-wrapper h2, #email-content-wrapper h3, #email-content-wrapper h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }\n#email-content-wrapper p, #email-content-wrapper li, #email-content-wrapper ul, #email-content-wrapper ol { line-height: 1.5; }\n#email-content-wrapper li:has(> ul), #email-content-wrapper li:has(> ol) { list-style: none; }\n#email-content-wrapper h1 { font-weight: 500; font-size: 40px; line-height: 1.2; letter-spacing: -0.25px; }\n#email-content-wrapper h2 { font-weight: 500; font-size: 28px; line-height: 1.25; letter-spacing: 0; }\n#email-content-wrapper h3 { font-weight: 500; font-size: 22px; line-height: 1.3; letter-spacing: 0.25px; }\n#email-content-wrapper h4 { font-weight: 500; font-size: 18px; line-height: 1.35; letter-spacing: 0; }\n@media only screen and (max-width: 480px) {\n  #email-content-wrapper h1 { font-size: 34px !important; line-height: 1.2 !important; }\n  #email-content-wrapper h2 { font-size: 24px !important; line-height: 1.25 !important; }\n  #email-content-wrapper h3 { font-size: 20px !important; line-height: 1.3 !important; }\n  #email-content-wrapper h4 { font-size: 16px !important; line-height: 1.35 !important; }\n}</style><p>Bonjour <span class="fr-deletable styled-tag-chip" contenteditable="false" data-custom-variable="{{firstname}}" style="background-color:rgb(248, 248, 255);border:1px solid rgb(191, 191, 255);border-radius:4px;color:rgb(42, 42, 196);padding:1px 8px;font-size:11px;line-height:16px;display:inline-block;margin:0px;overflow-wrap:anywhere;user-select:none;box-sizing:inherit" original-style="">Pr&eacute;nom</span>,</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;">Un grand merci d’avoir particip&eacute; &agrave; l’encan — votre soutien nous fait chaud au c&oelig;ur !</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;">Petit rappel : l’encan <strong>se termine bient&ocirc;t</strong>, c’est le moment parfait pour v&eacute;rifier vos mises, en ajouter une derni&egrave;re… ou tenter de remporter l’article que vous surveillez depuis le d&eacute;but ! 👀</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;">🕒 <strong>Fin de l’encan :</strong> <span class="fr-deletable styled-tag-chip" contenteditable="false" data-custom-variable="{{end-date-variable-561cbbc9-8260-4579-befd-3cce3ea9901a}}" style="background-color:rgb(248, 248, 255);border:1px solid rgb(191, 191, 255);border-radius:4px;color:rgb(42, 42, 196);padding:1px 8px;font-size:11px;line-height:16px;display:inline-block;margin:0px;overflow-wrap:anywhere;user-select:none;box-sizing:inherit" original-style="">Date de fin de l\'événement</span></p></div>',
            },
        },
    },
    "block-1788511558256-4": {
        type: "Button",
        data: {
            style: {
                backgroundColor: "#ffffff",
                fontSize: 14,
                fontFamily: "MODERN_SANS",
                fontWeight: "normal",
                textAlign: "center",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
            },
            props: {
                buttonBackgroundColor: "#0f0e5b",
                buttonTextColor: "#FFFFFF",
                buttonStyle: "rounded",
                fullWidth: false,
                size: "medium",
                text: "📍 Voir vos mises",
                url: "{{form_link}}",
            },
        },
    },
    "block-1788511558256-5": {
        type: "Html",
        data: {
            style: {
                color: "#0f0e5b",
                backgroundColor: "#ffffff",
                fontSize: 14,
                fontFamily: "MODERN_SANS",
                textAlign: "left",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
            },
            props: {
                contents: '<div id="email-content-wrapper"><style>#email-content-wrapper p, #email-content-wrapper h1, #email-content-wrapper h2, #email-content-wrapper h3, #email-content-wrapper h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }\n#email-content-wrapper p, #email-content-wrapper li, #email-content-wrapper ul, #email-content-wrapper ol { line-height: 1.5; }\n#email-content-wrapper li:has(> ul), #email-content-wrapper li:has(> ol) { list-style: none; }\n#email-content-wrapper h1 { font-weight: 500; font-size: 40px; line-height: 1.2; letter-spacing: -0.25px; }\n#email-content-wrapper h2 { font-weight: 500; font-size: 28px; line-height: 1.25; letter-spacing: 0; }\n#email-content-wrapper h3 { font-weight: 500; font-size: 22px; line-height: 1.3; letter-spacing: 0.25px; }\n#email-content-wrapper h4 { font-weight: 500; font-size: 18px; line-height: 1.35; letter-spacing: 0; }\n@media only screen and (max-width: 480px) {\n  #email-content-wrapper h1 { font-size: 34px !important; line-height: 1.2 !important; }\n  #email-content-wrapper h2 { font-size: 24px !important; line-height: 1.25 !important; }\n  #email-content-wrapper h3 { font-size: 20px !important; line-height: 1.3 !important; }\n  #email-content-wrapper h4 { font-size: 16px !important; line-height: 1.35 !important; }\n}</style><p>Chaque mise nous rapproche un peu plus de notre mission. Merci de faire partie de cette belle aventure !</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;">Bonne chance et bon encan !</p>\n<p style="line-height: 140%;">— L’&eacute;quipe de {{organization_name}}</p></div>',
            },
        },
    },
    "block-1788511558256-6": {
        type: "Image",
        data: {
            style: {
                backgroundColor: "#e1e1e1",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
                textAlign: "center",
            },
            props: {
                url: "{{organization_logo_url}}",
                width: 60,
                alt: "organization logo",
                linkHref: null,
                contentAlignment: "middle",
            },
        },
    },
    "block-1788511558256-7": {
        type: "Html",
        data: {
            style: {
                color: "#9c9c9c",
                backgroundColor: "#e1e1e1",
                fontSize: 14,
                fontFamily: "MODERN_SANS",
                textAlign: "center",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
            },
            props: {
                contents: '<div id="email-content-wrapper"><style>#email-content-wrapper p, #email-content-wrapper h1, #email-content-wrapper h2, #email-content-wrapper h3, #email-content-wrapper h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }\n#email-content-wrapper p, #email-content-wrapper li, #email-content-wrapper ul, #email-content-wrapper ol { line-height: 1.5; }\n#email-content-wrapper li:has(> ul), #email-content-wrapper li:has(> ol) { list-style: none; }\n#email-content-wrapper h1 { font-weight: 500; font-size: 40px; line-height: 1.2; letter-spacing: -0.25px; }\n#email-content-wrapper h2 { font-weight: 500; font-size: 28px; line-height: 1.25; letter-spacing: 0; }\n#email-content-wrapper h3 { font-weight: 500; font-size: 22px; line-height: 1.3; letter-spacing: 0.25px; }\n#email-content-wrapper h4 { font-weight: 500; font-size: 18px; line-height: 1.35; letter-spacing: 0; }\n@media only screen and (max-width: 480px) {\n  #email-content-wrapper h1 { font-size: 34px !important; line-height: 1.2 !important; }\n  #email-content-wrapper h2 { font-size: 24px !important; line-height: 1.25 !important; }\n  #email-content-wrapper h3 { font-size: 20px !important; line-height: 1.3 !important; }\n  #email-content-wrapper h4 { font-size: 16px !important; line-height: 1.35 !important; }\n}</style><p><strong>{{organization_name}}</strong></p></div>',
            },
        },
    },
};
